import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { GeoTiff } from '../../../../core/interfaces/solar-interfaces';

@Component({
  selector: 'app-geo-tiff-renderer',
  standalone: true,
  imports: [],
  templateUrl: './geo-tiff-renderer.component.html',
  styleUrl: './geo-tiff-renderer.component.css'
})
export class GeoTiffRendererComponent implements OnChanges {
  @Input() geoTiff!: GeoTiff;
  @Input() mask?: GeoTiff;
  @ViewChild('canvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;

  ngOnChanges(): void {
    if (this.geoTiff) {
      this.renderGeoTiff();
    }
  }

  private renderGeoTiff(): void {
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas dimensions
    canvas.width = this.mask ? this.mask.width : this.geoTiff.width;
    canvas.height = this.mask ? this.mask.height : this.geoTiff.height;

    const dw = this.geoTiff.width / canvas.width;
    const dh = this.geoTiff.height / canvas.height;
    const imgData = ctx.createImageData(canvas.width, canvas.height);

    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const rgbIdx = Math.floor(y * dh) * this.geoTiff.width + Math.floor(x * dw);
        const maskIdx = y * canvas.width + x;
        const imgIdx = (y * canvas.width + x) * 4;

        imgData.data[imgIdx] = this.geoTiff.rasters[0][rgbIdx]; // Red
        imgData.data[imgIdx + 1] = this.geoTiff.rasters[1][rgbIdx]; // Green
        imgData.data[imgIdx + 2] = this.geoTiff.rasters[2][rgbIdx]; // Blue
        imgData.data[imgIdx + 3] = this.mask ? this.mask.rasters[0][maskIdx] * 255 : 255; // Alpha
      }
    }

    ctx.putImageData(imgData, 0, 0);
  }
}
